import { http, normalizePage } from '@shared/api';
import type { Page, UUID } from '@shared/api';
import type { ProductDetail, ProductListItem } from './types';

export const productApi = {
  moderationQueue: async (params: {
    page?: number;
    size?: number;
  }): Promise<Page<ProductListItem>> => {
    const raw = await http
      .get('products/moderation-queue', {
        searchParams: { page: params.page ?? 0, size: params.size ?? 20 },
      })
      .json<unknown>();
    return normalizePage<ProductListItem>(raw);
  },

  get: (id: UUID) => http.get(`products/${id}`).json<ProductDetail>(),

  approve: (id: UUID) => http.post(`products/${id}/approve`).json<void>(),

  reject: (id: UUID, reason: string) =>
    http.post(`products/${id}/reject`, { json: { reason } }).json<void>(),
};
